import { defineMessages } from 'react-intl'

const scope = `procurify.core.hooks.useFormatCreditCardTypeToLabel`

export default defineMessages({
  otherCreditCard: {
    id: `${scope}.otherCreditCard`,
    defaultMessage: `Other`,
  },
  visa: {
    id: `${scope}.visa`,
    defaultMessage: `Visa`,
  },
  mastercard: {
    id: `${scope}.mastercard`,
    defaultMessage: `Mastercard`,
  },
  americanExpress: {
    id: `${scope}.americanExpress`,
    defaultMessage: `American Express`,
  },
  discover: {
    id: `${scope}.discover`,
    defaultMessage: `Discover`,
  },
  jcb: {
    id: `${scope}.jcb`,
    defaultMessage: `JCB`,
  },
  dinersClub: {
    id: `${scope}.dinersClub`,
    defaultMessage: `Diners Club`,
  },
})
